__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@cocounsel/file-management-mfe-client";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@cocounsel/harmonia", "1.2.0", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(32025))))));
			register("@cocounsel/prometheus/material", "3.0.161", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(14141))))));
			register("@cocounsel/prometheus", "3.0.161", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(6925)]).then(() => (() => (__webpack_require__(27452))))));
			register("@cocounsel/skills-mfe-client", "2.0.0", () => (__webpack_require__.e(8096).then(() => (() => (__webpack_require__(66289))))));
			register("@emotion/react", "11.13.3", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(58967))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914), __webpack_require__.e(3127)]).then(() => (() => (__webpack_require__(71479))))));
			register("@mui/material", "6.5.0", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(3127), __webpack_require__.e(6539)]).then(() => (() => (__webpack_require__(29922))))));
			register("@mui/x-data-grid-premium", "8.29.2", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(3127), __webpack_require__.e(6539), __webpack_require__.e(7391)]).then(() => (() => (__webpack_require__(85465))))));
			register("@mui/x-license", "8.29.2", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(29478))))));
			register("@tanstack/react-query-devtools", "5.100.6", () => (__webpack_require__.e(8096).then(() => (() => (__webpack_require__(56695))))));
			register("@tanstack/react-query", "5.100.6", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(85946))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-hook-form", "7.74.0", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(97286))))));
			register("react-intersection-observer", "9.16.0", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(80471))))));
			register("react", "18.3.1", () => (__webpack_require__.e(8096).then(() => (() => (__webpack_require__(96540))))));
			register("zustand", "4.5.7", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(34085))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};